import React from "react";

function CodeValueBox({ qrCodeValue }: { qrCodeValue: string | number }) {
  return (
    <div className="flex flex-col justify-center items-center px-3.5 py-3 w-full rounded-lg shadow-sm bg-neutral-600 max-md:max-w-full">
      <div className="flex items-center justify-center h-fit max-md:max-w-full text-[#AFFF6B] text-center leading-none text-2xl tracking-widest">
        {qrCodeValue}
      </div>
    </div>
  );
}

export default CodeValueBox;
